import GlobalHelper from "@utils/helper/GlobalHelper";
import { formatterBillingModelValue, formatterPayChannelsValue } from "../../../finance/util/financeBillingInfoUtils";
import DateUtil from "../../../../utils/DateUtil";

export default {
    /**
     * 格式化组织状态
     */
    formatterOrgStateStr(item) {
        // 是否是对象
        let state = item;
        if (GlobalHelper.isObject(item)) {
            state = item.state;
        }
        // 状态（0：过期，1:草稿，2：停用，3：审核驳回 100：注销）,
        if (state == 0) {
            return "停用";
        } else if (state == 1) {
            return "正常";
        } else if (state == 2) {
            return "待审核";
        } else if (state == 3) {
            return "审核驳回";
        } else if (state == 100) {
            return "注销";
        } else {
            return this.formatterNoDefaultStr();
        }
    },
    /**
     * 使用模式
     */
    formatterBillingMode(item) {
        // 是否是对象
        let billingMode = item;
        if (GlobalHelper.isObject(item)) {
            billingMode = item.billingMode;
        }
        return formatterBillingModelValue(billingMode);
    },

    /**
     * 付费模式通道
     */
    formatterPaymentChannels(item) {
        if (!item) {
            return "-";
        }

        return formatterPayChannelsValue(item.paymentChannels);
    },
    /*
     * 地址
     * */
    formatterAddressStr(item) {
        let address = "";
        if (item.address && item.address.length != 0) {
            address = item.address;
        } else {
            !!item.province && (address += item.province);
            !!item.city && (address += item.city);
            !!item.district && (address += item.district);
        }
        if (!address || address.length == 0) {
            return "-";
        }
        return address;
    },

    /**
     *  显示默认字符
     */
    formatterNoDefaultStr() {
        return "-";
    },
};

/**
 * 处理选中的地址显示
 */
export const formatterSelectItemAddress = (item) => {
    let str = "";
    if (item.province != null && item.province.length != 0) {
        str = item.province;
    }
    if (item.city != null && item.city.length != 0) {
        str = `${str}-${item.city}`;
    }

    if (item.district != null && item.district.length != 0) {
        str = `${str}-${item.district}`;
    }
    return str;
};

/**
 * 时间日期
 */
export const formatterOrgDateTimeStr = (time) => {
    if (!time || time.length == 0) {
        return "-";
    }
    const result = DateUtil.formatterDateYMDStr(time);
    return result;
};

/**
 * 道路资格许可证有效时间
 */
export const formatterOrgRoadLicenseDateTimeStr = (item) => {
    const { roadLicenseStartDate, roadLicenseEndDate } = item;
    if (!roadLicenseStartDate || roadLicenseStartDate.length == 0) {
        return "-";
    }
    const result = `${DateUtil.formatterDateYMDStr(roadLicenseStartDate)}至${DateUtil.formatterDateYMDStr(roadLicenseEndDate)}`;
    return result;
};
/**
 * 营业执照有效时间
 */
export const formatterOrgBusinessLicenseDateTimeStr = (item) => {
    const { businessLicenseStartDate, businessLicenseEndDate, businessLicenseDateType } = item;
    if (!businessLicenseStartDate || businessLicenseStartDate.length == 0) {
        return "-";
    }
    let result = `${DateUtil.formatterDateYMDStr(businessLicenseStartDate)}至`;
    if (businessLicenseDateType == 0) {
        result += "长期";
    } else {
        result += DateUtil.formatterDateYMDStr(businessLicenseEndDate);
    }
    return result;
};
